import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_viewAudit = _resolveComponent("viewAudit")!
  const _component_editAudit = _resolveComponent("editAudit")!
  const _component_startAudit = _resolveComponent("startAudit")!
  const _component_auditControls = _resolveComponent("auditControls")!
  const _component_auditFindings = _resolveComponent("auditFindings")!
  const _component_controlEdit = _resolveComponent("controlEdit")!
  const _component_findingsInfo = _resolveComponent("findingsInfo")!
  const _component_findingTaskEdit = _resolveComponent("findingTaskEdit")!
  const _component_detailsModal = _resolveComponent("detailsModal")!

  return (_openBlock(), _createBlock(_component_detailsModal, {
    modelValue: _ctx.showDetailsModal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showDetailsModal) = $event)),
    title: _ctx.detailsHeader,
    showBack: _ctx.showDetailsBack,
    onClose: _ctx.closeDetailsModal,
    onBack: _ctx.backDetailsModal
  }, {
    default: _withCtx(() => [
      (_ctx.detailsView === 'viewAudit')
        ? (_openBlock(), _createBlock(_component_viewAudit, {
            key: 'viewAudit-' + _ctx.detailsParams.auditId,
            auditId: _ctx.detailsParams.auditId,
            modalMode: true,
            onHeaderInfo: _ctx.setDetailsHeader,
            onOpenNested: _ctx.openNested
          }, null, 8, ["auditId", "onHeaderInfo", "onOpenNested"]))
        : (_ctx.detailsView === 'createAudit')
          ? (_openBlock(), _createBlock(_component_editAudit, {
              key: 'createAudit',
              modalMode: true,
              onHeaderInfo: _ctx.setDetailsHeader,
              onOpenNested: _ctx.openNested
            }, null, 8, ["onHeaderInfo", "onOpenNested"]))
          : (_ctx.detailsView === 'editAudit')
            ? (_openBlock(), _createBlock(_component_editAudit, {
                key: 'editAudit-' + _ctx.detailsParams.auditId,
                auditId: _ctx.detailsParams.auditId,
                modalMode: true,
                onHeaderInfo: _ctx.setDetailsHeader,
                onOpenNested: _ctx.openNested
              }, null, 8, ["auditId", "onHeaderInfo", "onOpenNested"]))
            : (_ctx.detailsView === 'startAudit')
              ? (_openBlock(), _createBlock(_component_startAudit, {
                  key: 'startAudit-' + _ctx.detailsParams.auditId + '-' + (_ctx.detailsParams.tasks || ''),
                  auditId: _ctx.detailsParams.auditId,
                  tasks: _ctx.detailsParams.tasks,
                  modalMode: true,
                  onHeaderInfo: _ctx.setDetailsHeader,
                  onOpenNested: _ctx.openNested
                }, null, 8, ["auditId", "tasks", "onHeaderInfo", "onOpenNested"]))
              : (_ctx.detailsView === 'auditControls')
                ? (_openBlock(), _createBlock(_component_auditControls, {
                    key: 'auditControls-' + _ctx.detailsParams.auditId,
                    auditId: _ctx.detailsParams.auditId,
                    modalMode: true,
                    onHeaderInfo: _ctx.setDetailsHeader,
                    onOpenNested: _ctx.openNested
                  }, null, 8, ["auditId", "onHeaderInfo", "onOpenNested"]))
                : (_ctx.detailsView === 'auditFindings')
                  ? (_openBlock(), _createBlock(_component_auditFindings, {
                      key: 'auditFindings-' + _ctx.detailsParams.auditId,
                      auditId: _ctx.detailsParams.auditId,
                      modalMode: true,
                      onHeaderInfo: _ctx.setDetailsHeader,
                      onOpenNested: _ctx.openNested
                    }, null, 8, ["auditId", "onHeaderInfo", "onOpenNested"]))
                  : (_ctx.detailsView === 'controlEdit')
                    ? (_openBlock(), _createBlock(_component_controlEdit, {
                        key: 'controlEdit-' + _ctx.detailsParams.taskId,
                        auditId: _ctx.detailsParams.auditId,
                        taskId: _ctx.detailsParams.taskId,
                        myTasks: _ctx.detailsParams.myTasks,
                        modalMode: true,
                        onHeaderInfo: _ctx.setDetailsHeader,
                        onOpenNested: _ctx.openNested
                      }, null, 8, ["auditId", "taskId", "myTasks", "onHeaderInfo", "onOpenNested"]))
                    : (_ctx.detailsView === 'findingsInfo')
                      ? (_openBlock(), _createBlock(_component_findingsInfo, {
                          key: 'findingsInfo-' + _ctx.detailsParams.findingId,
                          findingId: _ctx.detailsParams.findingId,
                          modalMode: true,
                          onHeaderInfo: _ctx.setDetailsHeader,
                          onOpenNested: _ctx.openNested
                        }, null, 8, ["findingId", "onHeaderInfo", "onOpenNested"]))
                      : (_ctx.detailsView === 'findingTaskEdit')
                        ? (_openBlock(), _createBlock(_component_findingTaskEdit, {
                            key: 'findingTaskEdit-' + _ctx.detailsParams.taskId,
                            findingId: _ctx.detailsParams.findingId,
                            taskId: _ctx.detailsParams.taskId,
                            modalMode: true,
                            onHeaderInfo: _ctx.setDetailsHeader,
                            onOpenNested: _ctx.openNested
                          }, null, 8, ["findingId", "taskId", "onHeaderInfo", "onOpenNested"]))
                        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "title", "showBack", "onClose", "onBack"]))
}